import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AdminApp } from './admin/AdminApp';
import { copy } from './copy/es';
import './index.css';
import { PortalApp } from './portal/PortalApp';

function NoEncontrado() {
  return <p className="p-8 text-center text-gray-600">{copy.comun.noEncontrado}</p>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/p/*" element={<PortalApp />} />
        <Route path="*" element={<NoEncontrado />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
